import React, { useEffect, useState } from 'react'
import CustomDialog from '../../components/layouts/common/CustomDialog';
import { Box, Typography } from '@mui/material';
import CustomInput from '../../components/inputs/CustomInputs';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../store/actions/modalAction';
import { callApiAction } from '../../store/actions/commonAction';
import { getSalesPersonBycodeApi } from '../../apis/salesPerson.api';
import { useNavigate } from 'react-router';
import { CUSTOMER_TYPE } from '../../utils/constants';

const SalesPersonUi = ({ fields, setFields, loading, setSales_person_code, sales_person_code, mainStep, setMainStep }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [data, setData] = useState({ sales_person_name: "", sales_person_store: "" })
    const [search, setSearch] = useState("")

    const fetchSalesDetails = () => {
        dispatch(
            callApiAction(
                async () =>
                    await getSalesPersonBycodeApi({
                        sales_person_code: search
                    }),
                async (response) => {
                    setData({
                        ...data,
                        sales_person_name: response?.name,
                        sales_person_store: response?.store_id?.name
                    });

                },
                (err) => {
                    setData({ ...data, err });
                }
            )
        );
    };

    useEffect(() => {
        fetchSalesDetails();
    }, [search]);


    return (
        <>

            <CustomDialog

                disabledSubmit={data.sales_person_name == undefined || (data.sales_person_name != undefined && data.sales_person_name.toString().length == 0) || data.sales_person_store == undefined || (data.sales_person_store != undefined && data.sales_person_store.toString().length == 0)}
                id="SalesPerson"
                title={"Add Sales Person Details"}
                onClose={(e) => {
                    navigate("/customer")
                }}
                onSubmit={(e) => {
                    e.preventDefault()
                    setMainStep(1)
                    dispatch(closeModal("SalesPerson"))
                }}
                closeText={"Close"}
                confirmText={"Submit"}
            >
                <Box
                    p={1}
                    sx={{
                        borderRadius: "4px",
                    }}
                >
                    <Box
                        display={"flex"}
                        justifyContent={"space-between"}
                        flexDirection={"column"}
                    >
                        <Box width={"100%"}>
                            <CustomInput
                                disabled={loading}
                                value={fields.sales_person_code}
                                onChange={(e) => {
                                    setSales_person_code(e.target.value);
                                    setSearch(e.target.value);
                                }}
                                type="text"
                                autoFocus={true}
                                label={"Sales Person Code*"}
                                // onWheel={(e) => e.target.blur()}
                                sx={{
                                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                                    {
                                        WebkitAppearance: "none",
                                        margin: 0,
                                    },
                                    "& input": {
                                        MozAppearance: "textfield",
                                    },
                                }}
                            />
                        </Box>

                        <Box width={"100%"}>
                            <CustomInput
                                value={data.sales_person_name}
                                disabled={true}
                                type="text"
                                label={"Name*"}
                            />
                        </Box>

                        <Box width={"100%"}>
                            <CustomInput
                                disabled={true}
                                value={data.sales_person_store}
                                type="text"
                                label={"Store*"}
                            />
                        </Box>
                    </Box>
                </Box>
            </CustomDialog>
        </>
    )
}

export default SalesPersonUi